<template>
  <address>
    <template v-for="line in $props.lines">
      {{ line }}
    </template>

    {{ $props.locality }} {{ $props.postalCode }} {{ $props.country }}
  </address>
</template>

<script>
export default {
  props: {
    lines: {
      type: Array,
      required: true
    },
    locality: {
      type: String,
      required: true
    },
    postalCode: {
      type: String,
      required: true
    },
    country: {
      type: String,
      required: true
    }
  }
}
</script>
